import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./App.css";
import NotificationBanner from "./Components/Common/NotificationBanner";
import { UpdateBanner } from "./Components/Common/UpdateBanner";
import Navbar from "./Components/Header/Navbar";
import { useServiceWorkerUpdate } from "./hooks/useServiceWorkerUpdate";
import GptRoutes from "./Routes/Routes";
import { defaultTheme, devTheme, sandboxTheme } from "./theme";
function App() {
  const env = process.env.REACT_APP_ENVIRONMENT || "prod";
  const currentTheme =
    env === "dev" ? devTheme : env === "sandbox" ? sandboxTheme : defaultTheme;
  const { newVersionAvailable, updateNow } = useServiceWorkerUpdate();



  return (
    <div className="App">
      <ChakraProvider theme={currentTheme}>
        <ToastContainer />
        <Router>
          <Navbar />
          <NotificationBanner />
          {newVersionAvailable && <UpdateBanner onUpdate={updateNow} />}
          <GptRoutes />
        </Router>
      </ChakraProvider>
    </div>
  );
}
export default App;
